import Axios from '@/plugins/axios.js'
import { payUrl } from '@/utils/config.js'
// 获取套餐包列表
export function getSubscribeKitList(data) {
  return Axios({
    url: '/order-api/subscribe/kit/list',
    method: 'GET',
    params: data,
  })
}

// 创建订单
export function createOrder(data) {
  return Axios({
    url: '/order-api/create',
    method: 'POST',
    data,
    noMessage: true,
  })
}

// 创建订单
export function getorderDetail(data) {
  return Axios({
    url: '/order-api/order-to-pay',
    method: 'POST',
    data,
  })
}

// 订单支付-获取支付单号信息
export function getPrePay(data) {
  return Axios({
    url: '/order-api/pre-pay',
    method: 'POST',
    data,
    noMessage: true,
  })
}

// 订单支付-生成支付宝二维码
export function generateDimensionalZfbCode(data) {
  return Axios({
    url: payUrl + '/pay/alipay/pay',
    method: 'POST',
    data,
  })
}

// 订单支付-生成微信二维码
export function generateDimensionalWxCode(data) {
  return Axios({
    url: payUrl + '/pay/wechat/pay',
    method: 'POST',
    data,
  })
}

// 获取订单状态
export function getOrderStatus(data) {
  return Axios({
    url: '/order-api/pay/get-result',
    method: 'GET',
    params: data,
  })
}
// 公共数据字典
export function getSingleDictByType(key) {
  const config = {
    url: '/order-api/common/data-dict/get-dict-by-type/' + key,
    method: 'GET',
  }
  return Axios(config)
}

// 订单列表
export function getOrderList(data) {
  return Axios({
    url: '/order-api/list',
    method: 'POST',
    data
  })
}
// 检查订单是否支付（检测订单状态变更，待支付&&订单未过期可以停留在当前页面，否则跳出）
export function pendingPayment(data) {
  return Axios({
    url: '/order-api/pending-payment',
    method: 'GET',
    params: data,
  })
}

// 获取对公支付账号信息
export function corporatePrePublicPay(data) {
  return Axios({
    url: '/order-api/pay/pre-public-pay',
    method: 'POST',
    data,
  })
}

// 对公支付
export function corporatPublicPay(data) {
  return Axios({
    url: '/order-api/pay/public-pay',
    method: 'POST',
    data,
  })
}

// 合同申请接口
export function contractApplication(data) {
  return Axios({
    url: '/order-api/contract/apply',
    method: 'POST',
    data,
    noMessage: true,
  })
}

// 头部费用
export function getOrderCostHeader() {
  return Axios({
    url: '/order-api/cost/header',
    method: 'GET',
  })
}
// 取消订单
export function cancelOrder(data) {
  return Axios({
    url: '/order-api/cancel',
    method: 'POST',
    data
  })
}
// 保存凭证
export function saveReceipt(data) {
  return Axios({
    url: '/order-api/pay/save-receipt',
    method: 'POST',
    data
  })
}

// 优惠券信息检测

export function couponInfo(data) {
  return Axios({
    url: `/order-api/coupon-info`,
    method: 'GET',
    params: data,
  })
}
